import  ShareDownloadsModal from '@/components/share_downloads_modal.js';
import  {useState} from 'react'

export default function ShortcodeResourceModalButton({product, classes, label, type}) {

  const [showDownload, setShowDownload] = useState(false);
  return (

    <>
      <a
        onClick={() => setShowDownload(true)  }
        target="_blank"
        className={classes }
      >
        {label || (type === 'share' ? 'Share' : 'Downloads') }
      </a>

      {showDownload  && (
        <ShareDownloadsModal product={product }  setShowShare={setShowDownload} showShare={showDownload } 
        type={type || 'download'}  />
      )}
    </>

  )

}
